/* Copyright 2013 - 2024 Waiterio LLC */
/* eslint-disable comma-dangle, quote-props, quotes */

export default [
  // {"countryCode":"AR","name":"Buenos Aires"},
  //
  // {"countryCode":"AT","name":"Wien"},
  //
  // {"countryCode":"BE","name":"Brussels"},

  // {"countryCode":"BR","name":"Rio de Janeiro"},
  // {"countryCode":"BR","name":"São Paulo"},

  // {"countryCode":"CL","name":"Santiago"},
  //
  // {"countryCode":"CO","name":"Bogotá"},
  // {"countryCode":"CO","name":"Cali"},
  // {"countryCode":"CO","name":"Medellín"},
  //
  { countryCode: 'DE', name: 'Berlin' },
  // {"countryCode":"DE","name":"Düsseldorf"},
  // {"countryCode":"DE","name":"Essen"},
  // {"countryCode":"DE","name":"Frankfurt"},
  // {"countryCode":"DE","name":"Hamburg"},
  // {"countryCode":"DE","name":"Köln"},
  // {"countryCode":"DE","name":"Leipzig"},
  // {"countryCode":"DE","name":"Munich"},
  // {"countryCode":"DE","name":"Nürnberg"},
  // {"countryCode":"DE","name":"Stuttgart"},
  //
  // {"countryCode":"ES","name":"Alicante"},
  { countryCode: 'ES', name: 'Barcelona' },
  // {"countryCode":"ES","name":"Córdoba"},
  // {"countryCode":"ES","name":"Granada"},
  { countryCode: 'ES', name: 'Madrid' },
  { countryCode: 'ES', name: 'Málaga' },
  // {"countryCode":"ES","name":"Murcia"},
  { countryCode: 'ES', name: 'Sevilla' },
  // {"countryCode":"ES","name":"Palma De Mallorca"},
  { countryCode: 'ES', name: 'Valencia' },
  //
  // {"countryCode":"FR","name":"Audenge"},
  // {"countryCode":"FR","name":"Bordeaux"},
  // {"countryCode":"FR","name":"Dijon"},
  // {"countryCode":"FR","name":"Lyon"},
  // {"countryCode":"FR","name":"Marseille"},
  // {"countryCode":"FR","name":"Montpellier"},
  // {"countryCode":"FR","name":"Nice"},
  // {"countryCode":"FR","name":"Paris"},
  // {"countryCode":"FR","name":"Rennes"},
  // {"countryCode":"FR","name":"Toulouse"},
  //
  // {"countryCode":"GB","name":"Birmingham"},
  // {"countryCode":"GB","name":"Bradford"},
  // {"countryCode":"GB","name":"Brighton"},
  // {"countryCode":"GB","name":"Edinburgh"},
  // {"countryCode":"GB","name":"Glasgow"},
  // {"countryCode":"GB","name":"Manchester"},
  // {"countryCode":"GB","name":"Norwich"},
  // {"countryCode":"GB","name":"Liverpool"},
  // {"countryCode":"GB","name":"Leeds"},
  // {"countryCode":"GB","name":"London"},
  //
  // {"countryCode":"GR","name":"Αθήνα"},
  // {"countryCode":"GR","name":"Θεσσαλονίκη"},
  //
  // {"countryCode":"HK","name":"Hong Kong"},
  //
  { countryCode: 'HU', name: 'Budapest' },
  //
  // {"countryCode":"ID","name":"Jakarta"},
  //
  // {"countryCode":"IN","name":"Ahmedabad"},
  // {"countryCode":"IN","name":"Bangalore"},
  // {"countryCode":"IN","name":"Chennai"},
  // {"countryCode":"IN","name":"Delhi"},
  // {"countryCode":"IN","name":"Hyderabad"},
  // {"countryCode":"IN","name":"Jaipur"},
  // {"countryCode":"IN","name":"Kolkata"},
  // {"countryCode":"IN","name":"Mumbai"},
  // {"countryCode":"IN","name":"New Delhi"},
  // {"countryCode":"IN","name":"Pune"},
  //
  // {"countryCode":"IN","name":"Chennai"},
  // {"countryCode":"IN","name":"Pune"},
  // {"countryCode":"IN","name":"Delhi"},
  // {"countryCode":"IN","name":"Hyderabad"},
  // {"countryCode":"IN","name":"New Delhi"},
  { countryCode: 'IN', name: 'Kolkata' },

  // {"countryCode":"IT","name":"Bari"},
  { countryCode: 'IT', name: 'Bologna' },
  // {"countryCode":"IT","name":"Catania"},
  { countryCode: 'IT', name: 'Firenze' },
  { countryCode: 'IT', name: 'Genova' },
  { countryCode: 'IT', name: 'Milano' },
  { countryCode: 'IT', name: 'Napoli' },
  { countryCode: 'IT', name: 'Palermo' },
  { countryCode: 'IT', name: 'Roma' },
  { countryCode: 'IT', name: 'Torino' },
  // {"countryCode":"IT","name":"Verona"},

  { countryCode: 'MX', name: 'Chihuahua' },
  { countryCode: 'MX', name: 'Ciudad de México' },
  { countryCode: 'MX', name: 'Guadalajara' },
  { countryCode: 'MX', name: 'Mérida' },
  { countryCode: 'MX', name: 'Monterrey' },
  // {"countryCode":"MX","name":"Morelia"},
  // {"countryCode":"MX","name":"Puebla"},
  // {"countryCode":"MX","name":"Querétaro"},
  // {"countryCode":"MX","name":"Tijuana"},
  // {"countryCode":"MX","name":"Zapopan"},
  //
  // {"countryCode":"MY","name":"Kuala Lumpur"},
  //
  // {"countryCode":"PE","name":"Lima"},

  { countryCode: 'PK', name: 'Karachi' },
  // {"countryCode":"PK","name":"Lahore"},
  //
  // {"countryCode":"SG","name":"Singapore"},
  //
  // {"countryCode":"TH","name":"กรุงเทพมหานคร"},
  // {"countryCode":"TH","name":"เชียงใหม่"},
  //
  // {"countryCode":"US","name":"Brooklyn"},
  // {"countryCode":"US","name":"Bronx"},
  // {"countryCode":"US","name":"Chicago"},
  // {"countryCode":"US","name":"San Diego"},
  // {"countryCode":"US","name":"Houston"},
  // {"countryCode":"US","name":"Lake Charles"},
  // {"countryCode":"US","name":"Las Vegas"},
  // {"countryCode":"US","name":"Los Angeles"},
  // {"countryCode":"US","name":"New York"},
  // {"countryCode":"US","name":"Philadelphia"},
  // {"countryCode":"US","name":"San Antonio"},
  // {"countryCode":"US","name":"San Francisco"},
  // {"countryCode":"US","name":"Seattle"}
]
